/**
 * O armazém: o app inteiro é coleção de documentos aqui dentro.
 * Espelha `server/src/dados_rotas.js`.
 */

/** `[A-Za-z0-9_-]{1,64}` dos dois lados. O servidor recusa antes do banco. */
export type NomeColecao = string;

export interface Documento<T = Record<string, unknown>> {
  id: string;
  dados: T;
}

/** `GET /dados?colecao=` */
export interface Pagina<T = Record<string, unknown>> {
  itens: Array<Documento<T>>;
  /** Onde o armazém está agora. Guarde para retomar o fluxo daqui. */
  seq: number;
}

/** O que `PUT /dados` e `POST /dados/apagar` devolvem, e o que o fluxo manda. */
export interface Evento<T = Record<string, unknown>> {
  seq: number;
  colecao: NomeColecao;
  id: string;
  /** Ausente quando o evento é de remoção. */
  dados?: T;
  apagado?: boolean;
}

/**
 * O primeiro quadro do fluxo, sem `id:` para não mexer no ponto de retomada.
 * Sem ele a tela não distingue "coleção vazia" de "ainda não chegou".
 */
export interface Pronto {
  pronto: true;
  seq: number;
}

export type QuadroDoFluxo<T = Record<string, unknown>> = Evento<T> | Pronto;

export function ehPronto(q: QuadroDoFluxo): q is Pronto {
  return (q as Pronto).pronto === true;
}
